import React from "react";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";

const STATUS_UI = {
  ACTIVE: {
    className: "marketplace-badge is-active",
    label: "Active",
    Icon: BoltOutlinedIcon,
  },
  HIDDEN: {
    className: "marketplace-badge is-coming-soon",
    label: "Hidden",
    Icon: VisibilityOffOutlinedIcon,
  },
  RETIRED: {
    className: "marketplace-badge is-disabled",
    label: "Retired",
    Icon: BlockOutlinedIcon,
  },
  REVOKED: {
    className: "marketplace-badge is-disabled",
    label: "Revoked",
    Icon: BlockOutlinedIcon,
  },
  EXPIRED: {
    className: "marketplace-badge is-disabled",
    label: "Expired",
    Icon: BlockOutlinedIcon,
  },
  PENDING: {
    className: "marketplace-badge is-coming-soon",
    label: "Pending",
    Icon: VisibilityOffOutlinedIcon,
  },
};

/**
 * Status pill for catalogue items and addon grants.
 */
const MarketplaceStatusBadge = ({ status }) => {
  const key = String(status || "").toUpperCase();
  const cfg = STATUS_UI[key] || {
    className: "marketplace-badge is-disabled",
    label: key || "Unknown",
    Icon: BlockOutlinedIcon,
  };
  const Icon = cfg.Icon;

  return (
    <span className={cfg.className}>
      <Icon sx={{ fontSize: 14 }} />
      {cfg.label}
    </span>
  );
};

export default MarketplaceStatusBadge;
